import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Users } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { PROGRAM_LABEL } from "@/lib/constants";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const RecruitmentStd = () => {
  const [std, setStd] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/job-orders/settings/std").then((r) => setStd(r.data)).catch(() => {}); }, []);
  if (!std) return null;
  const save = async () => { setBusy(true); try { const r = await api.put("/job-orders/settings/std", std); setStd(r.data); toast.success("Standar peserta tersimpan"); } catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); } };
  return (
    <div className="surface p-5 mb-5 space-y-3" data-testid="recruitment-std">
      <div><p className="font-heading font-semibold flex items-center gap-2"><Users className="h-4 w-4" />Standar Peserta per Program</p><p className="text-xs text-muted-foreground mt-1">Jumlah kandidat yang disiapkan per 1 kuota job order. Jumlah Kandidat = Kuota × standar ini (mis. SSW 2×, Magang 3×).</p></div>
      <div className="grid sm:grid-cols-3 gap-3">
        {["ssw", "magang", "pmi_non_jepang", "engineering"].map((k) => <label key={k} className="text-sm"><span className="text-xs text-muted-foreground">{PROGRAM_LABEL(k)}</span><div className="flex items-center gap-2 mt-1"><Input type="number" min={1} max={10} value={std[k]} onChange={(e) => setStd({ ...std, [k]: +e.target.value })} data-testid={`std-${k}`} className="w-24" /><span className="text-xs text-muted-foreground">× kuota</span></div></label>)}
      </div>
      <Button size="sm" onClick={save} disabled={busy} data-testid="std-save">Simpan standar</Button>
    </div>
  );
};
